import ReactDOM from "react-dom";
import "./scss/styles.scss";
import App from "./App";
import React from "react";


ReactDOM.render(
    <App />, 
    document.getElementById("root")
)